<template>
  <div class="up-wrapper">
    <label class="upload-label" @click="() => {this.$refs.inputFileUp.click()}" :style="{width:lw,height:lh}" >
      <div v-if="ifShowImg" class="cover-show">
        <img :src="showWhickImg" class="img" @error="imgLoadErr">
        <!--<i class="iconfont el-icon-close" @click.stop="delCoverImg"></i>-->
        <div v-if="showPreview" class="preview-img" @click.stop="()=>{}">
          <div class="wrap">
            <i class="el-icon-zoom-in preview-icon" @click.stop="dialogVisible = true" v-if="showScaleBig"></i>
            <i class="el-icon-delete preview-icon" @click.stop="delCoverImg" v-if="dis_upload"></i>
          </div>
        </div>
      </div>
      <div class="no-img" v-else >
        <i class="el-icon-plus cover-up-icon"></i>
        <span class="btn-text">上传图片</span>
      </div>
      <div v-show="showPercent"
           class="progress" @click.stop="()=>{}">
        <el-progress type="circle"
                     :width="progressSize"
                     :percentage="percent"></el-progress>
      </div>
    </label>
    <input
      type="file"
      ref="inputFileUp"
      @click="fileInputClick($event)"
      @change="coverImgChange($event)"
      style="display:none !important;"
    >
    <!-- <div class="upload__tip">请上传 jpg 格式的文件，且文件大小不得超过 5M</div> -->
    <el-dialog :width="dw"
               :top="dt"
               :visible.sync="dialogVisible">
      <img width="100%" :src="showWhickImg" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { upImage } from "@/api/common/api";
import { correctStatus } from "@/assets/js/apiStatus";
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "UpImage",
  props: {
    imgval: {
      type: String,
      required: true
    },
    cover: {
      type: String,
      default: ''
    },
    dis_upload:{
      type:Boolean,
      default:true,
    },
    // 图片加载失败时候的默认图url
    defaultImg: {
      type: String,
      default: ''
    },
    ltSize: {
      type: Object,
      default() {
        return {
          msg: "上传图片大小不能超过10MB!",
          reg: 10
        };
      }
    },
    ltFormat: {
      type: Object,
      default() {
        return {
          msg: "仅支持jpg,jpeg,png,gif格式的图片",
          reg: /^.*\.(jpg|png|jpeg|gif)$/i
        };
      }
    },
    progressSize: {
      type: Number,
      required: false,
      default: 98
    },
    dw: {
      type: String,
      required: false,
      default: "450px"
    },
    dt: {
      type: String,
      required: false,
      default: "7vh"
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: true
    },
    lw:{
      type: String,
      required: false,
      default: "150px"
    },
    lh:{
      type: String,
      required: false,
      default: "100px"
    },
    showScaleBig:{
      required:false,
      type:Boolean,
      default:true,
    }
  },
  data() {
    return {
      coverUrl: '', // 上传图片后,后台返回的图片链接url
      copyCover: this.cover, // 回显图片的链接url
      imgErr: false,
      percent: 0,
      showPercent: false,
      dialogVisible: false,
    };
  },
  methods: {
    imgLoadErr() {
      console.log('err err err',this.showWhickImg)
      this.imgErr = true;
    },
    delCoverImg() {
      this.coverUrl = "";
      this.copyCover = ''
      this.$emit("update:imgval", "");
    },
    // 点击上传文件之后,清空type="file"输入框的值,防止选择上次选择那个文件时不触发input的change事件
    fileInputClick(event) {
      event.target.value = null;
    },
    coverImgChange(event) {
      const file = event.target.files[0];
      const isJPG_PNG = this.ltFormat.reg.test(file.name);
      const isLt5M = file.size / 1024 / 1024 <= this.ltSize.reg;

      if (!isLt5M) {
        this.$message({
          type: "error",
          message: this.ltSize.msg
        });
      }
      if (!isJPG_PNG) {
        this.$message({
          type: "error",
          message: this.ltFormat.msg
        });
      }

      if (isJPG_PNG && isLt5M) {
        // 调用后台上传图片的接口
        this.ajaxUp(file)
      }
    },
    ajaxUp(file) {
      let upParams = new FormData();
      upParams.append("image", file);
      upParams.append("filename", file.name);
      this.coverUrl = "";
      this.copyCover = '';
      this.percent = 0;
      this.showPercent = true;
      upImage(upParams, this.progressFn).then(({ data }) => {
        if (data.status === correctStatus) {
          this.imgErr = false;
          this.coverUrl = window.URL.createObjectURL(file);
          this.$emit("update:imgval", data.result.image_url);
        } else {
          this.coverUrl = "";
          this.copyCover = '';
          this.$emit("update:imgval", "");
        }
        this.showPercent = false;
      });
    },
    progressFn(e) {
      this.percent = parseInt((e.loaded/e.total)*100);
    },
  },
  computed: {
    // 是否有图片要展示，
    ifShowImg() {
      return this.coverUrl || this.copyCover
    },
    // 要展示回显的图片还是上传的图片，优先展示上传的图片
    showWhickImg() {
      return this.imgErr ? this.defaultImg : this.ifShowImg
    },
  },
  watch: {
    cover: {
      handler(val) {
        this.copyCover = val;
      }
    },
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'

.up-wrapper
  display block
  .upload-label
    position relative
    display block
    /*width 150px*/
    /*height 100px*/
    background-color #f3f3f3
    cursor pointer
    color #8c939d
    // border 1px dashed #8c939d
    .cover-show
      display block
      position relative
      width 100%
      height 100%
      .preview-img
        display none
        width 100%
        height 100%
        position absolute
        top 0
        left 0
        z-index 100
        background-color $color_black
        opacity 0.8
        .wrap
          width 100%
          height 100%
          display flex
          justify-content center
          align-items center
          .preview-icon
            margin 0 10px
            font-size $font_size_big
            color $color_white
      .img
        display block
        width 100%
        height 100%
      .iconfont
        color $color_white
        position absolute
        top 0
        right 0
        z-index 200
        font-size 12px
        line-height 1
        padding 2px
        background-color $color_suc
        // opacity 0.8
        border-radius 50%
        transform translate(43%, -43%)
        border 0.5px solid
      &:hover
        .preview-img
          display block
    .no-img
      display flex
      width 100%
      height 100%
      justify-content center
      align-items center
      flex-flow column
      .cover-up-icon
        font-size 30px
        margin-bottom 8px
      .btn-text
        line-height 1
    .progress
      width 100%
      height 100%
      display flex
      justify-content center
      align-items center
      position absolute
      top 0
      left 0
      z-index 100
      background-color $color_white
</style>


